export default __webpack_public_path__ + "static/media/play_arrow.83395075.svg";